/* eslint-disable no-empty */
import { toast } from 'react-toastify'
import Zergling from '../helpers/zergling';
import Config from "../config/main";
import {BETSLIP_ADD, BETSLIP_REMOVE, CHANGE_HORSE_EVENT_TYPE, CHANGE_TYPE_TO_FORECAST_OR_TRICAST, BETSLIP_CLEAR, BETSLIP_SET_TYPE, BETSLIP_TOGGLE_QUICKBET, BETSLIP_ACCEPT_CHANGES,
    BETSLIP_BET_ACCEPTED, BETSLIP_BET_FAILED, BETSLIP_SET_STAKE, BETSLIP_SET_UNIT_STAKE, BETSLIP_SET_EACH_WAY_MODE,
    BETSLIP_SET_SYSTEM_OPT, BETSLIP_SET_ACCEPT_OPT, BETSLIP_SET_INCLUDE_IN_SYSTEM_CALC, BETSLIP_RESET_STATUS,
    BETSLIP_BET_PROCESSING, BETSLIP_QUICK_BET_NOTIFY, BETSLIP_QUICK_BET_NOTIFY_DISMISS, BETSLIP_TOGGLE_FREEBET,
    BETSLIP_TOGGLE_SUPERBET, BETSLIP_SET_FREE_BETS, BETSLIP_SELECT_FREE_BET, BETSLIP_UNSELECT_FREE_BET, BETSLIP_TOGGLE_FREEBET_LOADING_STATE, BETSLIP_TOGGLE_COUNTER_OFFER,
    BETSLIP_TOGGLE_BOOKINGBET, SET_UK_BETSLIP_OPTION_STAKE, TOGGLE_UK_BETSLIP_MULTIPLE_OPTIONS, UPDATE_BETSLIP_EVENTS,
    UNSET_UK_BETSLIP_OPTION, UNSET_UK_BETSLIP_OPTION_STAKE, SET_BET_EVENT_COUNTER_OFFER_ODD, BETSLIP_SET_ALL_EVENTS_STAKE, UPDATE_EVENT_FROM_BET_ERROR, BETSLIP_REPEAT_BET, BETSLIP_CLEAR_LAST_BET, BETSLIP_SET_ACTIVE_EVENT,
    BETSLIP_SET_SYSTEM_ACTIVE_INPUT,
    BETSLIP_SET_OFFERED_PRICE
} from './actionTypes/';

import Helpers from "../helpers/helperFunctions";
import {t} from "../helpers/translator";
import {getErrorMessageByCode, errorCodes} from "../constants/errorCodes";
import {PrintTicket} from "./terminal";
import {
    BETSLIP_TYPE_EXPRESS,
    BETSLIP_TYPE_SYSTEM, createBetRequests, createBetRequestsForUkBetslip, createBetslipEventObject,
    createResetedBetslipEvent
} from "../helpers/sport/betslip";
import OddConverter from "@common/helpers/oddConverter";

import {UILoading, UILoadingDone, UILoadingFailed, OpenPopup, ClosePopup, UIClose} from "./ui";
import {FavoriteAdd} from "./favorites";
import {GetUserBalance} from "./balance";
import { BetPriceChangeEnum } from '../constants/enums/betPriceChange';
import { result } from 'lodash';

/**
 * @name BetslipAdd
 * @description Add
 * @param {Object} payload bet event info
 * @returns {Function} async action dispatcher
 */
export const BetslipAdd = (payload) => {
    /**
     * @event betslipAdd
     */
    return {
        type: BETSLIP_ADD,
        payload
    };
};
/**
 * @name changeHorseEventType
 * @description change sp type to price
 * @param {Number} id
 * @param {String} type
 * @returns {Object} New state
 */
export const changeHorseEventType = (id, type, gameId) => {
    return {
        type: CHANGE_HORSE_EVENT_TYPE,
        payload: { id, type, gameId }
    };
};

export const changeTypeToForCastOrTriCast = (type) => {
    return {
        type: CHANGE_TYPE_TO_FORECAST_OR_TRICAST,
        payload: { type }
    };
};
/**
 * @name BetslipRemove
 * @description Remove given event from betslip
 * @param {Number} eventId
 * @returns {Object} New state
 */
export const BetslipRemove = (eventId, withHorse = false) => {
    /**
     * @event betslipRemove
     */
    return {
        type: BETSLIP_REMOVE,
        payload: {eventId, withHorse}
    };
};

/**
 * @name BetslipClear
 * @description Clear all events from betslip
 * @param {Boolean} processedOnly
 * @returns {Object} New state
 */
export const BetslipClear = (processedOnly = false, betPlaced = false) => {
    /**
     * @event betslipClear
     */
    return {
        type: BETSLIP_CLEAR,
        processedOnly,
        betPlaced,
    };
};

/**
 * @name BetslipMarkBetProcessing
 * @description Mark in progress Bets
 * @param {Array} eventIds
 * @param {Boolean} state
 * @returns {Object} New state
 */
export const BetslipMarkBetProcessing = (eventIds, state = true) => {
    /**
     * @event betslipMarkBetProcessing
     */
    return {
        type: BETSLIP_BET_PROCESSING,
        eventIds,
        state
    };
};
/**
 * @name BetslipSetType
 * @description Set betslip type
 * @param {Number} betSlipType
 * @returns {Object} New state
 */
export const BetslipSetType = (betSlipType) => {
    /**
     * @event betslipSetType
     */
    return {
        type: BETSLIP_SET_TYPE,
        betSlipType
    };
};

/**
 * @name BetslipSetFreeBets
 * @description Set free bets
 * @param {Object} payload
 * @returns {Object} New state
 */
export const BetslipSetFreeBets = (payload) => {
    /**
     * @event betslipSetFreeBets
     */
    return {
        type: BETSLIP_SET_FREE_BETS,
        payload
    };
};

/**
 * @name BetslipSelectFreeBet
 * @description Select free Bet Events
 * @param {Number} id
 * @param {Number} amount
 * @returns {Object} New state
 */
export const BetslipSelectFreeBet = (id, amount) => {
    /**
     * @event betslipSelectFreeBet
     */
    return {
        type: BETSLIP_SELECT_FREE_BET,
        id,
        amount
    };
};

/**
 * @name BetslipUnSelectFreeBet
 * @description UnSelect free Bet Events
 * @returns {{type}}
 * @constructor
 */
export const BetslipUnSelectFreeBet = () => {
    /**
     * @event betslipUnSelectFreeBet
     */
    return {
        type: BETSLIP_UNSELECT_FREE_BET
    };
};

/**
 * @name BetslipToggleQuickBet
 * @description  Toggle quick bet switcher
 * @param {Boolean} enabled
 * @returns {Object} New state
 */
export const BetslipToggleQuickBet = (enabled) => {
    /**
     * @event betslipToggleQuickBet
     */
    return {
        type: BETSLIP_TOGGLE_QUICKBET,
        enabled
    };
};

/**
 * @name BetslipToggleBookingBet
 * @description  Toggle booking bet switcher
 * @param {Boolean} enabled
 * @returns {Object} New state
 */
export const BetslipToggleBookingBet = (enabled) => {
    /**
     * @event betslipToggleBookingBet
     */
    return {
        type: BETSLIP_TOGGLE_BOOKINGBET,
        enabled
    };
};

/**
 * @name BetslipToggleFreeBet
 * @description  Toggle free bet switcher
 * @param {Boolean} enabled
 * @returns {Object} New state
 */
export const BetslipToggleFreeBet = (enabled) => {
    /**
     * @event betslipToggleFreeBet
     */
    return {
        type: BETSLIP_TOGGLE_FREEBET,
        enabled
    };
};

/**
 * @name BetslipToggleSuperBet
 * @description  Toggle super bet switcher
 * @param {Boolean} enabled
 * @returns {Object} New state
 */
export const BetslipToggleSuperBet = (enabled) => {
    /**
     * @event betslipToggleSuperBet
     */
    return {
        type: BETSLIP_TOGGLE_SUPERBET,
        enabled
    };
};

/**
 * @name BetslipAcceptChanges
 * @description Accept Odds change
 * @returns {Object} New state
 */
export const BetslipAcceptChanges = () => {
    /**
     * @event betslipAcceptChanges
     */
    return {
        type: BETSLIP_ACCEPT_CHANGES
    };
};

/**
 * @name BetslipBetAccepted
 * @description  Bet accepted by backend
 * @param {Object} payload
 * @returns {Object} New state
 */
export const BetslipBetAccepted = (payload) => {
    /**
     * @event betslipBetAccepted
     */
    let amount = payload.details.amount;
    return {
        type: BETSLIP_BET_ACCEPTED,
        payload,
        amount
    };
};

/**
 * @name BetslipBetFailed
 * @description  Bet not accepted by backend
 * @param {Object} payload
 * @returns {Object} New state
 */
export const BetslipBetFailed = (payload) => {
    /**
     * @event betslipBetFailed
     */
    return {
        type: BETSLIP_BET_FAILED,
        payload
    };
};
/**
 * @name BetslipQuickBetNotify
 * @description Show Quick bet result
 * @param {Number} id
 * @param {String} resultType
 * @param {String} payload
 * @returns {Object} New state
 */
export const BetslipQuickBetNotify = (id, resultType, payload) => {
    /**
     * @event betslipQuickBetNotify
     */
    return {
        type: BETSLIP_QUICK_BET_NOTIFY,
        id,
        resultType,
        payload
    };
};

/**
 * @name BetslipQuickBetDismissNotification
 * @description Dismiss Quick bet Notification for given bet id
 * @param {Number} id
 * @returns {Object} New state
 */
export const BetslipQuickBetDismissNotification = (id) => {
    /**
     * @event betslipQuickBetDismissNotification
     */
    return {
        type: BETSLIP_QUICK_BET_NOTIFY_DISMISS,
        id
    };
};

/**
 * @name BetslipResetStatus
 * @description Reset betslip status
 * @returns {Object} New state
 */
export const BetslipResetStatus = () => {
    /**
     * @event betslipResetStatus
     */
    return {
        type: BETSLIP_RESET_STATUS
    };
};
/**
 * @name BetslipSetStake
 * @description Set betslip Stake
 * @param {Number} value
 * @param {Number} eventId
 * @returns {Object} New state
 */
export const BetslipSetStake = (value, eventId) => {
    /**
     * betslipSetStake
     */
    return {
        type: BETSLIP_SET_STAKE,
        value,
        eventId
    };
};

export const BetslipSetOfferedPrice = (value, eventId) => {
    /**
     * betslipSetStake
     */
    return {
        type: BETSLIP_SET_OFFERED_PRICE,
        value,
        eventId
    };
};

/**
 * @name BetslipSetOptionStake
 * @description Set betslip Stake
 * @param {object} value
 * @returns {Object} New state
 */
export const BetslipSetOptionStake = value => {
    /**
     * betslipSetStake
     */
    return {
        type: SET_UK_BETSLIP_OPTION_STAKE,
        ...value
    };
};

/**
 * @name BetslipSetInclInSysCalc
 * @description Set betslip Stake
 * @param {Number} value
 * @param {Number} eventId
 * @returns {Object} New state
 */
export const BetslipSetInclInSysCalc = (value, eventId) => {
    /**
     * @event betslipSetInclInSysCalc
     */
    return {
        type: BETSLIP_SET_INCLUDE_IN_SYSTEM_CALC,
        value,
        eventId
    };
};
/**
 * @name BetslipSetUnitStake
 * @description Set betslip unit stake
 * @param {Number} value
 * @param {Number} eventId
 * @returns {Object} New state
 */
export const BetslipSetUnitStake = (value, eventId) => {
    /**
     * @event betslipSetUnitStake
     */
    return {
        type: BETSLIP_SET_UNIT_STAKE,
        value,
        eventId
    };
};

/**
 * @name BetslipSetEachWayMode
 * @description  Enable or disable each way mode
 * @param {Boolean} value
 * @returns {Object} New state
 */
export const BetslipSetEachWayMode = (value) => {
    /**
     * @event betslipSetEachWayMode
     */
    return {
        type: BETSLIP_SET_EACH_WAY_MODE,
        value
    };
};

export const UpdateEventFromBetError = (data) => {
    return {
        type: UPDATE_EVENT_FROM_BET_ERROR,
        payload: {
            eventId: data.details.selection_id,
            price: parseFloat(data.details.actual_price)
        }
    };
};

/**
 * @name BetslipSetSystemOpt
 * @description Set betslip system Option
 * @param {Number} value option type
 * @returns {Object} New state
 */
export const BetslipSetSystemOpt = (value) => {
    /**
     * @event BetslipSetSystemOpt
     */
    return {
        type: BETSLIP_SET_SYSTEM_OPT,
        value
    };
};

/**
 * @name BetslipSetAcceptOpt
 * @description Set betslip odds change accepting options
 * @param {Number} value
 * @returns {Object} New state
 */
export const BetslipSetAcceptOpt = (value) => {
    /**
     * @event betslipSetAcceptOpt
     */
    return {
        type: BETSLIP_SET_ACCEPT_OPT,
        value
    };
};

/**
 * @name BetslipToggleFreeBetLoadingState
 * @description toggle free bet loading state
 * @param {bool} payload
 * @returns {object} plain JavaScript object
 */
export const BetslipToggleFreeBetLoadingState = (payload) => {
    /**
     * @event betslipToggleFreeBetLoadingState
     */
    return {
        type: BETSLIP_TOGGLE_FREEBET_LOADING_STATE,
        payload
    };
};

/**
 * @name BetslipGetEventMaxBet
 * @description Get max bet value for given event ids
 * @param {Object | Array} betEvents
 * @returns {Function} async action dispatcher
 */
export const BetslipGetEventMaxBet = (betEvents, horseType, terminal) => {
    /**
     * @event betslipGetEventMaxBet
     */
    return function (dispatch) {
        dispatch(UILoading("getMaxBet"));
        let request = {}, id;
        let typeId = (horseType !== null && horseType !== "NO_FORECAST") ? horseType : 2
        if (Array.isArray(betEvents)) {
            request = {
                selection_list: betEvents.map(betEvent => ({SelectionId: betEvent.eventId})),
                type_id: typeId,
                token: terminal.authData.token
            };
        } else {
            request = {
                selection_list: [{SelectionId: betEvents.eventId}],
                type_id: 1,
                token: terminal.authData.token
            };
            id = betEvents.eventId;
        }
        Zergling.get(request, 'terminal_get_bet_max_stake')
            .then(result => {
                const { data: { MaxStake = 0 } = {} } = result;
                dispatch(BetslipSetStake(parseFloat(MaxStake), id));
                dispatch(BetslipSetUnitStake(parseFloat(MaxStake / 2), id));
                dispatch(UILoadingDone("getMaxBet"));
            })
            .catch((reason) => {
                dispatch(UILoadingFailed("getMaxBet", reason));
            });
    };
};

/**
 * @name GetSuperBetInfo
 * @description Get super bet info by bet ib
 * @param {Number} betId bet id
 * @returns {Function} async action dispatcher
 * @constructor
 */
export const GetSuperBetInfo = (betId) => {
    /**
     * @event getSuperBetInfo
     */
    return function (dispatch) {
        dispatch(UILoading("getSuperBetInfo"));
        Zergling.get({where: {bet_id: betId, outcome: 0}}, 'bet_history')
            .then(result => {
                console.log("Super bet info recived:", result);
                dispatch(UILoadingDone("getSuperBetInfo"));
                dispatch(OpenPopup("CounterOfferDialog", {betInfo: result.bets[0]}));
            })
            .catch((reason) => {
                dispatch(UILoadingFailed("getSuperBetInfo", reason));
            });
    };
};

/**
 * @name BetslipLoadFreeBets
 * @description Loads free bet options for bets in betslip
 * @returns {Function} async action dispatcher
 * @constructor
 */
export const BetslipLoadFreeBets = (ukBetslip = false) => {
    /**
     * @event betslipLoadFreeBets
     */
    return function (dispatch, getState) {
        const state = getState()
        const requests = !ukBetslip ? createBetRequests(getState().betslip, null, true) : createBetRequestsForUkBetslip(state.betslip, null, true);

        if (requests && requests.length) {
            dispatch(BetslipToggleFreeBetLoadingState(true));
            Zergling.get(requests[0], 'get_freebets_for_betslip')
                .then(result => {
                    if (result && result.details && result.details.length) {
                        dispatch(BetslipSetFreeBets(result.details.reduce((acc, curr) => {
                            curr.amount && acc.push(curr);
                            return acc;
                        }, [])));
                    } else {
                        dispatch(BetslipSetFreeBets([]));
                        dispatch(BetslipSelectFreeBet(null));
                    }
                    dispatch(BetslipToggleFreeBetLoadingState(false));
                })
                .catch((reason) => {
                    console.warn("get_freebets_for_betslip error", requests, reason);
                    dispatch(BetslipSetFreeBets([]));
                    dispatch(BetslipSelectFreeBet(null));
                    dispatch(BetslipToggleFreeBetLoadingState(false));
                });
        }
    };
};

export const BetslipRepeatBet = () => ({ type: BETSLIP_REPEAT_BET });
export const BetslipClearLastBet = () => ({ type: BETSLIP_CLEAR_LAST_BET });

/**
 * @name BetslipPlaceBet
 * @description Places a bet
 * @param {Object} betSlipData betslip data from store
 * @param {Object} currency currency object, needed for calculating superbet limits
 * @param {bool} freeBet
 * @param {Object} profile
 * @returns {Function} async action dispatcher
 * @constructor
 */

export const BetslipSetSystemActiveInput = (activeInput) => ({
    type: BETSLIP_SET_SYSTEM_ACTIVE_INPUT,
    activeInput
})

export const BetslipSetActiveEvent = (eventId) => ({
    type: BETSLIP_SET_ACTIVE_EVENT,
    eventId
})

export const BetslipPlaceBet = (betSlipData, currency = null, freeBet = false, profile, callback, terminal, userAuthData, loyalCard, oddsFormat, isConfirmed) => {
    /**
     * @name getBetSlipError
     * @description generating betslip error
     * @param {object} result
     * @returns {string}
     */
    // eslint-disable-next-line camelcase
    let external_id = loyalCard;
    function getBetSlipError (result) {
        let code;
        if (result && result.details && result.details.api_code) {
            code = "api_" + result.details.api_code;
        } else {
            code = Math.abs(parseInt(result.code || result.result || 99, 10)).toString();
        }
        // var code = Math.abs(parseInt(result.code || result.result || 99, 10)).toString();
        var isKnownError = getErrorMessageByCode(code, false);
        if (isKnownError) {
            return t(getErrorMessageByCode(code));
        } else if (Config.main.overrideErrorMessages && Config.main.overrideErrorMessages[code]) {
            code = Config.main.overrideErrorMessages[code];
            return t(getErrorMessageByCode(code));
        }
        return (t("Sorry, we can't accept your bets now, please try later.") + " " + code);
    }

    /**
     * @name showQuickBetNotification
     * @description generating notification for quick bets
     * @param {object} responseData
     * @param {string} type
     * @param {function} dispatch
     * @returns {string}
     * @fire event:showQuickBetNotification
     */
    function showQuickBetNotification (responseData, type, dispatch) {
        console.log("showQuickBetNotification", responseData, type);
        if (betSlipData.quickBet) {
            let eventId = Helpers.firstElement(betSlipData.events).eventId;
            dispatch(BetslipQuickBetNotify(eventId, type, type === "error" ? getBetSlipError(responseData) : t("Bet {1} accepted", eventId)));
            setTimeout(() => { dispatch(BetslipQuickBetDismissNotification(eventId)); }, Config.betting.quickBetNotificationsTimeout);
        }
    }

    /**
     * @event betslipPlaceBet
     */
    return function (dispatch) {
        dispatch(BetslipResetStatus());
        function processBetResults (data) {
            dispatch(UILoadingDone("bet"));
            if (data.result === "OK") {
                let events = data.details.events || data.details.selection_list || [];
                data.details.events = data.details.events || events;
                //add to favorites
                Config.isPartnerIntegration && (Config.isPartnerIntegration.mode.iframe || Config.isPartnerIntegration.needToLoginFromUrl) && dispatch(GetUserBalance(profile));

                Config.betting.resetAmountAfterBet && !betSlipData.quickBet && dispatch(BetslipSetStake(null));
                if (betSlipData.quickBet) {
                    showQuickBetNotification(data, "success", dispatch);
                } else {
                    data.isConfirmed = isConfirmed;
                    dispatch(BetslipBetAccepted(data));
                }
                if (data.details.needs_confirmation) {
                    let requestId = data.details.request_id;
                    dispatch(OpenPopup("confirmBet", { requestId, disable: true }));
                    return;
                }
                if (data.details.is_super_bet) {
                    let superBetId = data.details.id,
                        superbetAmount = data.details.amount,
                        superbetPrice = data.details.price;

                    dispatch(OpenPopup("superbet", {
                        disable: true,
                        superBetId,
                        superbetAmount,
                        superbetPrice
                    }));
                }
                Config.betting.enableRetainSelectionAfterPlacment || dispatch(BetslipClear(true, true));
                console.log("removing status info in ", Config.betting.betAcceptedMessageTime);
                Config.betting.betAcceptedMessageTime && setTimeout(() => { dispatch(BetslipResetStatus()); }, Config.betting.betAcceptedMessageTime);
                Config.main.closeBetslipAfterBetTime && setTimeout(() => {
                    dispatch(UIClose("betslip"));
                }, Config.betting.closeBetslipAfterBetTime);
                if (!data.details.is_super_bet && (!(userAuthData && userAuthData.auth_token) || Config.terminal.printUserBet)) {
                    dispatch(PrintTicket(JSON.stringify({
                        ...data.details,
                        price: OddConverter(data.details.price, oddsFormat),
                        selection_list: data.details.selection_list.map(item => ({...item, price: OddConverter(item.price, oddsFormat)}))
                    })));
                }
                callback && callback();
            } else {
                let generalBetResult;
                let failedSelecitonId;
                if (data.result === -1) {
                    generalBetResult = getBetSlipError(data);
                } else if (data.result === 3019) {
                    generalBetResult = t("Incompatible bet") + `(${data.result})`;
                } else if (data.result === -3019) {
                    generalBetResult = t(data.details?.error_message);
                    failedSelecitonId = data.details?.selection_id;
                } else if (data.result === -1800) { //Odds have been changed do update in swarmDataBetslip
                    generalBetResult = t("Odds have been changed");
                    dispatch(UpdateEventFromBetError(data));
                } else if (data.result === -2200) {
                    if (data.details && data.details.max_allowed_bet_stake) {
                        generalBetResult = t("Sorry, maximum bet stake is {1} {2}", data.details.max_allowed_bet_stake, ((terminal.authData && terminal.authData.currency) || 'EUR'));
                    } else {
                        generalBetResult = t("Sorry, you exceed maximum bet limit");
                    }
                } else {
                    //Handle BBIN api error messages
                    if (data && data.details && data.details.api_code) {
                        generalBetResult = getBetSlipError(data);
                    } else if (errorCodes[data.result]) {
                        let code = Config.main.overrideErrorMessages && Config.main.overrideErrorMessages[data.result]
                            ? Config.main.overrideErrorMessages[data.result]
                            : data.result + ((data.result === '1510' && Config.betting.allowManualSuperBet) ? '_sb' : '');
                        generalBetResult = t(getErrorMessageByCode(code));
                    } else {
                        generalBetResult = getBetSlipError(data);
                    }
                }

                if (betSlipData.quickBet) {
                    showQuickBetNotification(data, "error", dispatch);
                } else {
                    dispatch(BetslipBetFailed({ reason: generalBetResult, selectionId: failedSelecitonId }));
                }
                setTimeout(() => { dispatch(BetslipResetStatus()); }, Config.betting.betAcceptedMessageTime);
            }
        }
        let betPromises = [];
        dispatch(UILoading("bet"));

        dispatch(BetslipMarkBetProcessing(Object.keys(betSlipData.events)));
        var requests = createBetRequests(betSlipData, terminal.authData.currency, freeBet);
        requests.map(request => {
            betPromises.push(
                Zergling.get((() => {
                    //todo delete this after terminal software release
                    //<<<<
                    // userAuthData && userAuthData.auth_token ? request.token = userAuthData.auth_token : request.token = terminal.authData.token;
                    // return request;
                    //>>>>
                    //uncomment this after terminal software release
                    //<<<<
                    if (userAuthData && userAuthData.user_id) {
                        request.client_id = userAuthData.user_id;
                        request.is_player_betting = true;
                    }
                    // eslint-disable-next-line camelcase
                    if (external_id) {
                        // eslint-disable-next-line camelcase
                        request.member_id = external_id;
                    }
                    if (Config.betNeedConfirmation && !isConfirmed) {
                        request.needs_confirmation = true;
                    }
                    //request.client_id = (userAuthData && userAuthData.user_id) ? userAuthData.user_id : null;
                    request.token = terminal.authData.token;
                    request.is_super_bet = betSlipData.superBet;
                    return request;
                })(), "do_bet_terminal")
                    //>>>>
                //})(), userAuthData && userAuthData.auth_token ? "do_bet" : "do_bet_terminal")
                    .then(processBetResults)
                    .catch((reason) => {
                        dispatch(UILoadingFailed("bet", reason));
                        console.log("bet failed", reason);
                        if (reason.code === 12) { // not logged in
                            dispatch(OpenPopup("LoginForm"));
                        } else {
                            processBetResults(reason);
                        }
                    }).then((data) => {
                    // refresh bonus for integration skins
                    // if (Config.partner.balanceRefreshPeriod || Config.main.rfid.balanceRefreshPeriod) {
                    //     dispatch(); //TODO
                    // }
                    })
            );
        });
        Promise.all(betPromises).then(() => {
            dispatch(UILoadingDone("bet"));
        });
    };
};

/**
 * @name UkBetslipPlaceBet
 * @description Places a bet
 * @param {Object} betSlipData betslip data from store
 * @param {Object} currency currency object, needed for calculating superbet limits
 * @param {bool} freeBet
 * @param {Object} profile
 * @returns {Function} async action dispatcher
 * @constructor
 */
export const UkBetslipPlaceBet = (betSlipData, currency = null, freeBet = false, profile) => {
    /**
     * @name getBetSlipError
     * @description generating betslip error
     * @param {object} result
     * @returns {string}
     */
    function getBetSlipError (result) {
        let code;
        if (result.details && result.details.api_code) {
            code = "api_" + result.details.api_code;
        } else {
            code = Math.abs(parseInt(result.code || result.result || 99, 10)).toString();
        }
        /*var code = Math.abs(parseInt(result.code || result.result || 99, 10)).toString();*/
        var isKnownError = getErrorMessageByCode(code, false);
        return isKnownError ? t(getErrorMessageByCode(code)) : (t("Sorry, we can't accept your bets now, please try later.") + " " + code);
    }

    /**
     * @name showQuickBetNotification
     * @description generating notification for quick bets
     * @param {object} responseData
     * @param {string} type
     * @param {function} dispatch
     * @returns {string}
     * @fire event:showQuickBetNotification
     */
    function showQuickBetNotification (responseData, type, dispatch) {
        console.log("showQuickBetNotification", responseData, type);
        if (betSlipData.quickBet) {
            let eventId = Helpers.firstElement(betSlipData.events).eventId;
            dispatch(BetslipQuickBetNotify(eventId, type, type === "error" ? getBetSlipError(responseData) : t("Bet {1} accepted", eventId)));
            setTimeout(() => { dispatch(BetslipQuickBetDismissNotification(eventId)); }, Config.betting.quickBetNotificationsTimeout);
        }
    }

    /**
     * @event betslipPlaceBet
     */
    return function (dispatch) {
        dispatch(BetslipResetStatus());

        function processBetResults (data) {
            console.log("bet result", data);
            dispatch(UILoadingDone("bet"));
            if (data.result === "OK") {
                //add to favorites
                Config.isPartnerIntegration && Config.isPartnerIntegration.mode.iframe && dispatch(GetUserBalance(profile));
                data.details.events.map(event => { dispatch(FavoriteAdd("game", betSlipData.events[event.selection_id].gameId)); });

                Config.betting.resetAmountAfterBet && !betSlipData.quickBet && dispatch(BetslipSetStake(null));
                betSlipData.selectedFreeBetId && dispatch(BetslipUnSelectFreeBet());
                betSlipData.freeBet && dispatch(BetslipToggleFreeBet(false));

                if (betSlipData.quickBet) {
                    showQuickBetNotification(data, "success", dispatch);
                } else {
                    data.isConfirmed = true;
                    dispatch(BetslipBetAccepted(data));
                }
                Config.betting.enableRetainSelectionAfterPlacment || dispatch(BetslipClear(true, true));
                console.log("removing status info in ", Config.betting.betAcceptedMessageTime);
                Config.betting.betAcceptedMessageTime && setTimeout(() => { dispatch(BetslipResetStatus()); }, Config.betting.betAcceptedMessageTime);
            } else {
                let generalBetResult;
                if (data.result === -1) {
                    generalBetResult = getBetSlipError(data);
                } else if (data.result === 3019) {
                    generalBetResult = t("Incompatible bet") + `(${data.result})`;
                } else {
                    //Handle BBIN api error messages
                    if (data && data.details && data.details.api_code) {
                        generalBetResult = getBetSlipError(data);
                    } else if (errorCodes[data.result]) {
                        generalBetResult = t(getErrorMessageByCode(data.result + ((data.result === '1510' && Config.betting.allowManualSuperBet) ? '_sb' : '')));
                    } else {
                        generalBetResult = getBetSlipError(data);
                    }
                }

                if (betSlipData.quickBet) {
                    showQuickBetNotification(data, "error", dispatch);
                } else {
                    dispatch(BetslipBetFailed({reason: generalBetResult}));
                }
                setTimeout(() => { dispatch(BetslipResetStatus()); }, Config.betting.betAcceptedMessageTime);
            }
        }
        let betPromises = [], requests;
        dispatch(UILoading("bet"));
        dispatch(BetslipMarkBetProcessing(Object.keys(betSlipData.events)));
        requests = createBetRequestsForUkBetslip(betSlipData, currency, freeBet);

        requests.map(request => {
            betPromises.push(
                Zergling.get(request, 'do_bet')
                    .then(processBetResults)
                    .catch((reason) => {
                        dispatch(UILoadingFailed("bet", reason));
                        console.log("bet failed", reason);
                        if (reason.code === 12) { // not logged in
                            dispatch(OpenPopup("LoginForm"));
                        } else {
                            processBetResults(reason);
                        }
                    })
                    .then((data) => {
                        // refresh bonus for integration skins
                        // if (Config.partner.balanceRefreshPeriod || Config.main.rfid.balanceRefreshPeriod) {
                        //     dispatch(); //TODO
                        // }
                    })
            );
        });
        Promise.all(betPromises).then(() => {
            dispatch(UILoadingDone("bet"));
        });
    };
};

/**
 * @name BetslipBookBet
 * @description Book a bet
 * @param {Object} betSlipData betslip data from store
 * @returns {Function} async action dispatcher
 * @constructor
 */
export const BetslipBookBet = (betSlipData) => {
    /**
     * @event betslipGetEventMaxBet
     */
    let betEvents, price, posWin, typeId, amount, systemMinCount, betEventsFirstElem;
    betEvents = betSlipData.betslip.events;
    betEventsFirstElem = betEvents[Object.keys(betEvents)[0]];
    price = betSlipData.expOdds ? betSlipData.expOdds : betEventsFirstElem && (betEventsFirstElem.price || -1);
    posWin = betSlipData.posWin ? betSlipData.posWin : 0;
    // oddsFormat = betSlipData.oddsFormat.oddsFormat;
    typeId = (betSlipData.betslip.localBetslipHorseTypeOnlyTryCastForCast !== null && betSlipData.betslip.localBetslipHorseTypeOnlyTryCastForCast !== "NO_FORECAST") ? betSlipData.betslip.localBetslipHorseTypeOnlyTryCastForCast : betSlipData.betslip.type;
    amount = betSlipData.betslip.stake ? betSlipData.betslip.stake : betSlipData.betslip.unitStake;
    systemMinCount = typeId === 3 ? betSlipData.betslip.sysOptionValue : null;
    return function (dispatch) {
        let url, request = {};
        const betEventsKeys = Object.keys(betEvents)

        if (Config.main.useBetBookLastApi) {
            url = 'create_bet_book_v2',
            request.cashdesk_id = JSON.parse(sessionStorage.getItem("authData")).tid
            request.bets = [
                {
                    BetType: typeId,
                    Amount: betSlipData.betslip.unitStake,
                    Selections: betEventsKeys.reduce((acc, key) => acc.concat({SelectionId: betEvents[key].eventId, Price: betEvents[key].price }), [])
                }
            ]
        } else {
            url = 'book_bet'
            request = {type: typeId, amount: parseFloat(betSlipData.betslip.unitStake)};
            request.bets = betEventsKeys.reduce((acc, key) => acc.concat({event_id: betEvents[key].eventId, amount: betSlipData.betslip.unitStake}), []);

            if (betSlipData.betslip.type === BETSLIP_TYPE_SYSTEM) {
                request.sys_bet = betSlipData.betslip.sysOptionValue;
            }
        }

        dispatch(UILoading("getBookingBetId"));
        Zergling.get(request, url)
            .then(result => {
                dispatch(UILoadingDone("getBookingBetId"));
                const bookNum = Config.main.useBetBookLastApi ? result.details?.Id : result.details?.number;
                if (result.result === 0 && bookNum) {
                    dispatch(OpenPopup("bookingInfo", {bookNum, betEvents, price, posWin, typeId, amount, systemMinCount}));
                }
            })
            .catch((reason) => {
                dispatch(UILoadingFailed("getBookingBetId", reason));
            });
    };
};

export const UpdateBetslipEvents = (payload) => {
    return {
        type: UPDATE_BETSLIP_EVENTS,
        payload
    };
};

export const AddBetSlipEventFromUrl = (params, fromUrl = false) => {
    let eventIds = fromUrl ? params.event.split(",").map(Number) : params,
        stake = params && params.stake;
    return function (dispatch) {
        let request = {
            "source": "betting",
            "what": {
                "game": [],
                "market": [],
                "event": []
            },
            "where": {
                "event": {
                    "id": {
                        "@in": eventIds
                    }
                }
            }
        };
        Zergling.get(request).then(
            (res) => {
                if (Object.keys(res.data.game).length > 1) {
                    dispatch(BetslipSetType(BETSLIP_TYPE_EXPRESS));
                }
                res && res.data && res.data.game && Object.keys(res.data.game).map(gameId => {
                    let game = res.data.game[gameId];
                    game && game.market && Object.keys(game.market).map(marketId => {
                        let market = game.market[marketId],
                            eventId = Object.keys(market.event)[0],
                            event = market.event[eventId];
                            
                        dispatch(BetslipAdd(createBetslipEventObject(game, market, event, null))); //eslint-disable-line react/prop-types
                    });
                });
                Object.keys(res.data.game).length > 1 && dispatch(BetslipSetType(BETSLIP_TYPE_EXPRESS));
                stake && dispatch(BetslipSetStake(stake));
            }
        );
    };
};